<template>
  <DxTabPanel
    :element-attr="consumTabPanelAttributes"
    :data-source="consumSteps"
    :loop="false"
    :selected-item="currentItem"
    :selected-index="currentStep"
    :animation-enabled="true"
    :swipe-enabled="false"
    :show-nav-buttons="false"
    @selection-changed="tabSelectionChanged($event)"
  >
    <template #item="{ data: step }">
      <div>
        <div v-show="step == 1" class="consum_step consum_option_holder">
          <div v-for="option in consumOptions" :key="option.code" class="consum_selector_option" @click="consumOptionClick(option)">
            {{ $t(option.titleKey) }}
          </div>
        </div>

        <div v-show="step == 2" class="consum_step_map">
          <WorkListSelector
            ref="workListSelector"
            @showToastMessage="showToastMessage"
            v-if="currentConsumOption.code == consumTypes.Works && step == 2"
          ></WorkListSelector>
          <div v-if="currentConsumOption.code == consumTypes.Parcel && parcelSubPhase === 'parcel'" class="consum_parcel_view">
            <div v-if="showParcelSelectionOptions" class="consum_option_holder consum_sub_option_holder">
              <div
                v-for="option in parcelSelectionOptions"
                :key="option.code"
                class="consum_selector_option"
                @click="selectParcelSelectionOption(option)"
              >
                {{ $t(option.titleKey) }}
              </div>
            </div>
            <div v-else-if="parcelViewMode === 'map'">
              <google-map
                ref="googlemap"
                :showMap="step == 2"
                :selection_mode="true"
                :initial-season-uuid="season_uuid_local"
                :initMapInMount="true"
                mapClass="consum_map"
                :selected-parcel-uuids="selectedParcelUuids"
                :sync-selection-from-props="enableParcelMapListToggle"
                @showToastMessage="showToastMessage"
                @removeSelectedParcel="removeSelectedParcel"
                @addSelectedParcel="addSelectedParcel"
                @showMapFilter="showMapFilter"
              ></google-map>
              <button
                v-if="enableParcelMapListToggle"
                class="consum_view_toggle"
                type="button"
                @click="setParcelViewMode('list')"
              >
                <img src="@/assets/images/icons/list.svg" alt="List" />
              </button>
            </div>
            <div v-else class="consum_parcel_list">
              <ParcelListSelector
                :seasons="seasons"
                :selected-layer-uuids="selectedParcelUuids"
                :default-season-uuid="season_uuid_local"
                :show-toggle="enableParcelMapListToggle"
                @toggle-layer="toggleLayerFromList"
                @toggle-view="setParcelViewMode('map')"
                @season-change="onSeasonChange"
                @reset-selection="resetSelectedParcels"
              />
            </div>
          </div>
          <MachineSelector
            ref="parcelMachineSelector"
            :isRemoteOperation="true"
            :loaderPayload="{ autopropulsat: 1 }"
            :multiselect="true"
            v-if="currentConsumOption.code == consumTypes.Parcel && parcelSubPhase === 'machines' && step == 2"
          />
          <MachineSelector
            ref="machineSelector"
            :isRemoteOperation="true"
            :loaderPayload="{}"
            :multiselect="true"
            v-if="currentConsumOption.code == consumTypes.Machinery && step == 2"
          />
        </div>
        <DxScrollView ref="consumInputScroll" v-show="step == 4" class="consum_step transfer-input-scroll" :use-native="true">
          <div>
            <div class="consum_input_holder" :class="[{ input_holder_error: $v.consumData.consum_date.$error }]">
              <div @click="showCalendarSelector">
                <div class="input_label">{{ $t("common.date") }}</div>
                <div class="input_value">
                  <span>{{ consumData.consum_date }}</span>
                </div>
              </div>
              <div v-if="is_date_selector_visible">
                <FunctionalCalendar
                  :date-format="getDefaultDateFormat.toLowerCase()"
                  :is-date-range="false"
                  v-model="calendarData"
                  :change-month-function="true"
                  :change-year-function="true"
                  :is-date-picker="true"
                  @choseDay="calendarDayChosen"
                  @input="onDateSelected"
                ></FunctionalCalendar>
              </div>
            </div>
            <div class="consum_input_holder" @click="showProductSelector" :class="[{ input_holder_error: $v.consumData.products.$error }]">
              <div class="consum_parcel_select_edit">
                <div class="consum_parcel_info">
                  <div class="input_label">{{ $t("common.product") }}</div>
                  <div class="input_value">{{ getSelectedProduse() }}</div>
                  <div class="consum_input_second_value">
                    {{ consumData.products.length > 2 ? $t("stock_mobile.form.more_products_count", { count: consumData.products.length - 2 }) : "" }}
                  </div>
                </div>
                <div class="consum_parcel_edit_icon">
                  <i class="fa-regular fa-edit"></i>
                </div>
              </div>
            </div>
            <div class="consum_input_holder" v-if="currentConsumOption.code != consumTypes.Machinery">
              <div class="consum_parcel_select_edit">
                <div class="consum_parcel_info" @click="parcelsClick()">
                  <div class="input_label">{{ $t("common.parcels") }}</div>
                  <div class="input_value">{{ getParcelNames }}</div>
                  <div class="consum_input_second_value">{{ getSelectedParcelCountForInput }}</div>
                </div>
                <div
                  v-if="currentConsumOption.code == consumTypes.Parcel"
                  class="consum_parcel_edit_icon"
                  @click="parcelsClick(true)"
                >
                  <i class="fa-regular fa-edit"></i>
                </div>
              </div>
              <div
                v-if="(currentConsumOption.code == consumTypes.Parcel && selectedLayers.length > 0) || (currentConsumOption.code == consumTypes.Works && selectedWorksData.parcels.length > 0)"
                class="consum_parcel_map_link_holder"
              >
                <button class="consum_parcel_map_link" type="button" @click.stop="viewSelectedParcelsOnMap">
                  <i class="fa-solid fa-map" aria-hidden="true"></i>
                  {{ $t("stock_mobile.form.view_selected_parcels_on_map") }}
                </button>
              </div>
            </div>
            <div
              class="consum_input_holder"
              v-if="is_work_generator_enabled && currentConsumOption.code == consumTypes.Parcel"
              :class="[{ input_holder_error: $v.consumData.work_machines.$error }]"
            >
              <div class="input_label">{{ $t("stock_mobile.form.work") }}</div>
              <div>
                <dx-combo-with-add
                  ref="comboWorkTypes"
                  @selectionChanged="workSelected"
                  :allowAddNew="false"
                  :addNewText="$t('stock_mobile.form.work_not_exists')"
                  :comboDataset="workTypes"
                  :isComboDisabled="false"
                  :placeholder="$t('stock_mobile.form.select_work')"
                >
                </dx-combo-with-add>
              </div>
            </div>
            <div
              class="consum_input_holder"
              v-if="is_work_generator_enabled && currentConsumOption.code == consumTypes.Parcel"
              :class="[{ input_holder_error: $v.consumData.work_machines.$error }]"
              @click="machinesClickParcel()"
            >
              <div class="consum_parcel_select_edit">
                <div class="consum_parcel_info">
                  <div class="input_label">{{ $t("stock_mobile.form.tractor") }}</div>
                  <div class="input_value">{{ getWorkMachinesNames }}</div>
                </div>
                <div class="consum_parcel_edit_icon">
                  <i class="fa-regular fa-edit"></i>
                </div>
              </div>
            </div>
            <div v-if="currentConsumOption.code == consumTypes.Works">
              <div class="consum_input_holder">
                <div class="consum_parcel_select_edit">
                  <div class="consum_parcel_info">
                    <div class="input_label">{{ $t("stock_mobile.form.work") }}</div>
                    <div class="input_value">{{ getWorkTypeNames }}</div>
                  </div>
                </div>
              </div>
              <div class="consum_input_holder">
                <div class="consum_parcel_select_edit">
                  <div class="consum_parcel_info">
                    <div class="input_label">{{ $t("stock_mobile.form.tractor") }}</div>
                    <div class="input_value">{{ getTractorNames }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="consum_input_holder" v-if="currentConsumOption.code == consumTypes.Machinery">
              <div class="consum_parcel_select_edit">
                <div class="consum_parcel_info" @click="machinesClick()">
                  <div class="input_label">{{ $t("stock_mobile.form.machinery") }}</div>
                  <div class="input_value">{{ getMachineNames }}</div>
                </div>
                <div class="consum_parcel_edit_icon" @click="machinesClick()">
                  <i class="fa-regular fa-edit"></i>
                </div>
              </div>
            </div>
            <div class="consum_input_holder">
              <div class="input_label">{{ $t("common.notes") }}</div>
              <div class="input_value">
                <DxTextArea v-model="consumData.notes" class="global_dx_number_input" :height="45" />
              </div>
            </div>
            <div class="input-bottom-spacer"></div>
          </div>
        </DxScrollView>
        <DxScrollView v-show="step == 5" class="consum_step transfer-input-scroll" :use-native="true">
          <div>
            <div class="parcel_item_edit_surface" v-for="(layer, index) in selectedLayers ? selectedLayers : []" :key="index">
              <div class="parcel_surface_name">{{ layer.name }}</div>
              <div class="parcel_surface_editor">
                <div class="parcel_surface_label">{{ $t("works.work_list.worked_area") }}</div>
                <DxNumberBox
                  v-model="layer.surface"
                  class="parcel_surface_input"
                  :show-clear-button="false"
                  format="#0.## ha"
                />
              </div>
            </div>
          </div>
        </DxScrollView>

        <div
          class="consum_bottom_sticky"
          v-show="step == 2 && parcelSubPhase === 'parcel' && selectedLayers.length > 0"
        >
          <div class="sticky_action_button" @click="continueFromMap">{{ $t("common.continue") }}</div>
        </div>
        <div
          class="consum_bottom_sticky_transparent"
          v-show="step == 2 && currentConsumOption.code == consumTypes.Works && !continueButtonPressed"
        >
          <div class="sticky_action_button continue_from_work" @click="continueFromWorks">{{ $t("common.continue") }}</div>
        </div>
        <div class="consum_bottom_sticky" v-show="step == 2 && currentConsumOption.code == consumTypes.Machinery">
          <div class="sticky_action_button" @click="continueFromMachineSelection">{{ $t("common.continue") }}</div>
        </div>
        <div
          class="consum_bottom_sticky"
          v-show="step == 2 && currentConsumOption.code == consumTypes.Parcel && parcelSubPhase === 'machines'"
        >
          <div class="sticky_action_button" @click="continueFromMachineSelectionParcel">{{ $t("common.continue") }}</div>
        </div>
        <div class="save_bottom_sticky_two_line" v-show="step == 4 && showSaveButtons && !saveButtonPressed">
          <div class="sticky_action_button" @click="saveConsum(true)">{{ $t("stock_mobile.form.save_and_new_consumption") }}</div>
          <div class="sticky_action_button_second" @click="saveConsum(false)">{{ $t("common.save") }}</div>
        </div>
        <div class="consum_bottom_sticky" v-show="step == 5 && selectedLayers.length > 0">
          <div class="sticky_action_button" @click="applyParcelChanges">{{ $t("common.continue") }}</div>
        </div>
        <ProductSelectorMultiManager
          ref="productSelector"
          :showPopup="productSelectorVisibility"
          @hidden="hideProductSelector"
          @input="applyProductsSelection"
          :selectedProducts="consumData.products"
          :selectFromStock="true"
          :allowAddNew="false"
          :filterData="filterData"
          :totalArea="parseFloat(getSelectedParcelSurfaceDecimal)"
          :movementDate="consumData.consum_date"
          :transactionType="transactionTypeTitle"
          :showWarehouseSelector="true"
        >
        </ProductSelectorMultiManager>
        <MachineConsumSplitPopup ref="machineSplitPopup" />
        <MachineParcelSplitPopup ref="machineParcelSplitPopup" />
        <ParcelMapPopup
          v-if="step == 4 && workParcelMapVisible"
          :visible.sync="workParcelMapVisible"
          :parcel-uuids="workParcelUuids"
          :parcel-seasons="workParcelSeasons"
        />
        <toast-message ref="toastMessage"></toast-message>
      </div>
    </template>
  </DxTabPanel>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ConsumTypes, ConsumOptions, ParcelSelectionOptions } from "./consum.js";
import DxTabPanel from "devextreme-vue/tab-panel";
import ToastMessage from "../../../../components/Mobile/toastMessage.vue";
import GoogleMap from "@/components/Map/GoogleMap.vue";
import { DxScrollView } from "devextreme-vue/scroll-view";
import DxNumberBox from "devextreme-vue/number-box";
import DxSelectBox from "devextreme-vue/select-box";
import { required, helpers } from "vuelidate/src/validators";
import DxTextArea from "devextreme-vue/text-area";
import { FunctionalCalendar } from "vue-functional-calendar";
import moment from "moment";
import DxComboWithAdd from "@/components/Mobile/DxComboWithAdd/index.vue";
import ProductSelectorMultiManager from "../Product/ProductSelectorMultiManager.vue";
import WorkListSelector from "./WorkListSelector.vue";
import MachineSelector from "@/components/Mobile/MachineSelector.vue";
import MachineConsumSplitPopup from "./MachineConsumSplitPopup.vue";
import MachineParcelSplitPopup from "./MachineParcelSplitPopup.vue";
import { TransactionActions, TransactionOptions } from "../transactions.js";
import { extractErrorMessage } from "@/helpers/generalActions";
import ParcelListSelector from "@/pages/stock-mobile/partials/ParcelListSelector.vue";
import ParcelMapPopup from "@/components/Map/ParcelMapPopup.vue";

const requiredByParam = (value) => {
  return helpers.req(value) && value > 0;
};

const requiredWorkByParam = (requiredData, compare_uuid) => (value) => {
  /*
    const _compare_res = (is_work_generator_enabled && (compare_uuid != null && compare_uuid != ''));
    return _compare_res ? helpers.req(value) : true;
    */
  return requiredData ? helpers.req(value) : true;
};

export default {
  name: "Consum",
  props: {
    preselectProducts: {
      type: Object,
      default: null,
    },
    preselectedWorksData: {
      type: Object,
      default: null,
    },
    preselectedMachineForConsum: {
      type: Object,
      default: null,
    },
    enableParcelMapListToggle: {
      type: Boolean,
      default: false,
    },
    parcelInitialView: {
      type: String,
      default: "map",
    },
  },
  data() {
    return {
      tractorComboColumns: [
        { dataField: "registration_number", caption: this.$t("common.registration_number"), width: "100px" },
        { dataField: "name", caption: this.$t("common.name") },
      ],
      preselectDate: true,
      calendarData: {},
      consumSteps: [1, 2, 4, 5],
      currentStep: 0,
      currentItem: 1,
      currentConsumOption: {
        code: null,
        name: null,
      },
      tabPanelAttributes: {
        class: "consum_tabs",
      },
      selectedLayers: [],
      season_uuid_local: "",
      currentSeason: {},
      stockData: [],
      consumData: {
        products: [],
        parcels: [],
        consum_date: null,
        work_machines: [],
        work: {
          uuid: "",
          name: "",
        },
        notes: "",
      },
      parcelSubPhase: "parcel",
      machineConsumData: {
        machines: [],
      },
      filterData: {
        name: "",
      },
      is_date_selector_visible: false,
      is_work_generator_enabled: false,
      allow_stock_movement_only_in_legal_entity: false,
      workMachines: [],
      workTypes: [],
      productSelectorVisibility: false,
      saveButtonPressed: false,
      continueButtonPressed: false,
      selectedWorksData: {
        works: [],
        parcels: [],
        machines: [],
      },
      preselectedWorksApplied: false,
      preselectedMachineApplied: false,
      parcelViewMode: "map",
      selectedParcelSourceOption: null,
      pendingPreselectProducts: null,
      workParcelMapVisible: false,
    };
  },
  validations() {
    return {
      consumData: {
        products: {
          required,
          $each: {
            uuid: { required },
            quantity: { requiredByParam },
            warehouse_uuid: { required },
          },
        },
        consum_date: { required },
        work: {
          uuid: {
            requiredWorkByParam: requiredWorkByParam(
              this.is_work_generator_enabled && this.currentConsumOption.code == this.consumTypes.Parcel,
            ),
          },
        },
        work_machines: {
          requiredWorkByParam: requiredWorkByParam(
            this.is_work_generator_enabled && this.currentConsumOption.code == this.consumTypes.Parcel,
          ),
        },
      },
    };
  },
  components: {
    ParcelMapPopup,
    DxTabPanel,
    ToastMessage,
    GoogleMap,
    DxScrollView,
    DxNumberBox,
    DxSelectBox,
    DxTextArea,
    FunctionalCalendar,
    DxComboWithAdd,
    ProductSelectorMultiManager,
    WorkListSelector,
    MachineSelector,
    MachineConsumSplitPopup,
    MachineParcelSplitPopup,
    ParcelListSelector,
  },
  computed: {
    ...mapGetters({
      seasons: "seasons/seasons",
      getDefaultDateFormat: "settings/getDefaultDateFormat",
    }),
    consumTabPanelAttributes() {
      const classes = ["consum_tabs"];
      if (this.currentConsumOption.code === this.consumTypes.Works) {
        classes.push("consum_tabs_worklist");
      }
      return {
        class: classes.join(" "),
      };
    },
    transactionTypeTitle() {
      let title = TransactionOptions.find((opt) => opt.code === TransactionActions.Consum)?.title || "";

      this.currentConsumOption.code == this.consumTypes.Works
        ? (title += " " + this.$t("stock_mobile.form.for_work"))
        : this.currentConsumOption.code == this.consumTypes.Machinery
        ? (title += " " + this.$t("stock_mobile.form.for_machinery"))
        : (title += " " + this.$t("stock_mobile.form.for_parcel"));

      return title;
    },
    consumTypes() {
      return ConsumTypes;
    },
    consumOptions() {
      return ConsumOptions;
    },
    parcelSelectionOptions() {
      return ParcelSelectionOptions;
    },
    showParcelSelectionOptions() {
      return (
        this.enableParcelMapListToggle &&
        this.currentConsumOption.code == this.consumTypes.Parcel &&
        this.selectedParcelSourceOption == null
      );
    },
    getSelectedParcelSurfaceDecimal() {
      let ha = 0;
      if (this.currentConsumOption.code == this.consumTypes.Works) {
        ha =
          this.selectedWorksData.parcels && this.selectedWorksData.parcels.length > 0
            ? this.selectedWorksData.parcels
                .map((p) => p.surface_worked)
                .reduce((x, y) => {
                  return (parseFloat(x) + parseFloat(y)).toFixed(2);
                })
            : 0;
      } else {
        ha =
          this.selectedLayers && this.selectedLayers.length > 0
            ? this.selectedLayers
                .map((l) => l.surface)
                .reduce((x, y) => {
                  return (parseFloat(x) + parseFloat(y)).toFixed(2);
                })
            : 0;
      }
      return ha;
    },
    getSelectedParcelSurface() {
      return this.$t("stock_mobile.form.selected_hectares", { surface: this.getSelectedParcelSurfaceDecimal });
    },
    getSelectedParcelCount() {
      if (this.currentConsumOption.code == this.consumTypes.Works) {
        return this.$t("stock_mobile.form.parcel_count", { count: this.selectedWorksData.parcels.length });
      }

      return this.$t("stock_mobile.form.parcel_count", { count: this.selectedLayers.length });
    },
    getSelectedParcelCountForInput() {
      const parcel_count =
        this.currentConsumOption.code == this.consumTypes.Works ? this.selectedWorksData.parcels.length : this.selectedLayers.length;

      return this.$t("stock_mobile.form.selected_parcels_with_surface", {
        count: parcel_count,
        surface: this.getSelectedParcelSurfaceDecimal,
      });
    },
    selectedParcelUuids() {
      return this.selectedLayers.map((layer) => layer.uuid);
    },
    workParcelUuids() {
      return [...new Set(this.selectedWorksData.parcels.map((parcel) => parcel.uuid).filter(Boolean))];
    },
    workParcelSeasons() {
      const seasons = {};
      this.selectedWorksData.parcels.forEach((parcel) => {
        if (!parcel.uuid) return;
        if (!seasons[parcel.uuid]) seasons[parcel.uuid] = [];
        if (parcel.season_uuid && !seasons[parcel.uuid].includes(parcel.season_uuid)) seasons[parcel.uuid].push(parcel.season_uuid);
      });
      return seasons;
    },
    getParcelNames() {
      return this.currentConsumOption.code == this.consumTypes.Works
        ? [...new Set(this.selectedWorksData.parcels.map((p) => p.name))].join(", ")
        : this.selectedLayers.map((l) => l.name).join(", ");
    },
    showSaveButtons() {
      if (this.currentConsumOption.code == this.consumTypes.Works) {
        return this.consumData.products.length > 0 && this.consumData.consum_date && this.selectedWorksData.parcels.length > 0;
      } else if (this.currentConsumOption.code == this.consumTypes.Machinery) {
        return this.consumData.products.length > 0 && this.consumData.consum_date && this.machineConsumData.machines.length > 0;
      } else {
        const work = this.is_work_generator_enabled ? !!this.consumData.work.uuid && this.consumData.work_machines.length > 0 : true;
        return this.consumData.products.length > 0 && this.consumData.consum_date && this.selectedLayers.length > 0 && work;
      }
    },
    getTractorNames() {
      return [...new Set(this.selectedWorksData.machines.map((p) => p.name))].join(", ");
    },
    getWorkTypeNames() {
      return [...new Set(this.selectedWorksData.works.map((p) => p.name))].join(", ");
    },
    getMachineNames() {
      return this.machineConsumData.machines.map((m) => m.name).join(", ");
    },
    getWorkMachinesNames() {
      return this.consumData.work_machines.length > 0
        ? this.consumData.work_machines.map((m) => m.name).join(", ")
        : this.$t("stock_mobile.form.select_tractor");
    },
  },
  watch: {
    seasons: {
      handler: function (newVal) {
        this.setCurrentSeason(newVal);
      },
    },
    preselectProducts: {
      handler(newVal) {
        this.pendingPreselectProducts = this.clonePreselectedProducts(newVal);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    clonePreselectedProducts(value) {
      if (!value) {
        return null;
      }

      return JSON.parse(JSON.stringify(value));
    },
    consumePendingPreselectedProducts(departmentLegalEntityUuid = null) {
      if (!this.pendingPreselectProducts) {
        return;
      }

      const selectedWarehouseUuid = this.pendingPreselectProducts?.warehouse?.uuid || null;
      if (!selectedWarehouseUuid) {
        this.pendingPreselectProducts = null;
        return;
      }

      if (
        this.allow_stock_movement_only_in_legal_entity &&
        departmentLegalEntityUuid &&
        this.pendingPreselectProducts.warehouse_department_legal_entity_uuid != departmentLegalEntityUuid
      ) {
        this.$refs.toastMessage.showError("Entitatea legală a depozitului de recepție nu se potrivește cu entitatea legală a parcelelor selectate!");
        this.pendingPreselectProducts = null;
        return;
      }

      const products = Array.isArray(this.pendingPreselectProducts.products) ? this.pendingPreselectProducts.products : [];
      products.forEach((product) => {
        if (!product?.uuid) {
          return;
        }

        if (
          this.consumData.products.some(
            (p) => p.uuid === product.uuid && (p.warehouse_uuid || null) === selectedWarehouseUuid,
          )
        ) {
          return;
        }

        const selectedStock = Array.isArray(product.stock_list)
          ? product.stock_list.find((stock) => stock.warehouse_uuid === selectedWarehouseUuid)
          : null;

        this.consumData.products.push({
          uuid: product.uuid,
          name: product.name,
          quantity: product.quantity || 0,
          product_type: product.product_type,
          product_type_uuid: product.product_type?.uuid || null,
          warehouse_uuid: selectedWarehouseUuid,
          warehouse_name: selectedStock?.warehouse_name || this.pendingPreselectProducts.warehouse.name,
          warehouse_quantity: selectedStock?.quantity || 0,
          warehouse_department_legal_entity_uuid: this.pendingPreselectProducts.warehouse_department_legal_entity_uuid,
          measure_unit: product.measure_unit,
          measure_unit_id: product.measure_unit?.id || null,
          stock_list: product.stock_list,
          lot_management: product.lot_management ?? false,
          lot_items: product.lot_items ?? [],
        });
      });

      this.pendingPreselectProducts = null;
    },
    startFromOption(optionCode) {
      if (!optionCode) {
        return;
      }
      const option = this.consumOptions.find((opt) => opt.code === optionCode) || { code: optionCode, titleKey: "" };
      this.currentConsumOption = option;

      if (this.currentConsumOption.code == this.consumTypes.Works && this.applyPreselectedWorksDataIfAvailable()) {
        return;
      }

      if (this.currentConsumOption.code == this.consumTypes.Machinery && this.applyPreselectedMachineIfAvailable()) {
        return;
      }

      if (this.currentConsumOption.code == this.consumTypes.Parcel) {
        this.selectedParcelSourceOption = null;
        this.setParcelViewMode(this.parcelInitialView);
      }
      this.currentStep = 1;
      this.currentItem = this.consumSteps[this.currentStep];
      this.setTitle();
    },
    ...mapActions({
      getStockData: "smStocks/getSmStocks",
      getDepartments: "company/getDepartments",
      getSeasons: "seasons/getSeasons",
      createConsum: "smTransactions/createConsumTransaction",
      createMachineConsum: "smTransactions/createMachineConsumTransaction",
      getStockProductInfo: "smStocks/getSmStockProductInfo",
      getGroupByCode: "settings/getGroupByCode",
      getWorkMachines: "works-work-machines/getWorkMachines",
      getWorks: "works-manager/getWorks",
    }),
    tabSelectionChanged(e) {
      this.currentItem = e.addedItems[0];
      this.currentStep = this.consumSteps.indexOf(this.currentItem);
    },
    goBack() {
      if (this.currentStep == 2) {
        // if main edit/add screen
        this.$emit("goBackParent");
      } else if (this.currentStep == 1) {
        if (this.currentConsumOption.code == this.consumTypes.Parcel && this.parcelSubPhase === "machines") {
          // Return from tractor selection to the consumption form.
          this.parcelSubPhase = "parcel";
          this.currentStep = this.currentStep + 1;
          this.setTitle();
          return;
        }
        if (this.showParcelSelectionOptions) {
          this.currentStep = 0;
          this.setTitle();
          return;
        }
        // if map or works selector is open than go back to consum edit/add page
        this.currentStep = this.currentStep + 1;
        this.setTitle();
      } else if (this.currentStep > 0) {
        this.currentStep = this.currentStep - 1;
        this.setTitle(this.currentStep == 0);
      } else {
        this.$emit("goBackParent");
      }
    },
    setTitle() {
      if (this.currentStep == 0) {
        this.$emit("setTitle", this.$t("stock_mobile.form.consumption"), false);
      }
      if (this.currentStep >= 1) {
        if (this.currentStep == 1) {
          if (this.currentConsumOption.code == this.consumTypes.Works) {
            this.$emit("setTitle", this.$t("stock_mobile.form.product_consumption"), true, "", "", false /*, this.getSelectedParcelSurface, this.getSelectedParcelCount*/);
          } else if (this.currentConsumOption.code == this.consumTypes.Parcel) {
            this.$emit("setTitle", this.$t("stock_mobile.form.product_consumption"), true, this.getSelectedParcelSurface, this.getSelectedParcelCount);
          }
        } if (this.currentStep == 1 && (this.currentConsumOption.code == this.consumTypes.Parcel && this.parcelSubPhase === 'machines')) {
          this.$emit("setTitle", this.$t("works.work_machines.name"), true);
        } else {
          this.$emit("setTitle", this.$t("stock_mobile.form.product_consumption"), true);
        }
      }
    },
    getSelectedProduse() {
      if (this.consumData.products.length > 0) {
        if (this.consumData.products.length === 1) {
          return this.consumData.products[0].name;
        } else if (this.consumData.products.length > 1) {
          return this.consumData.products[0].name + ", " + this.consumData.products[1].name;
        }
      } else {
        return this.$t("stock_mobile.form.select_product");
      }
    },
    consumOptionClick(option) {
      if (option.code == this.consumTypes.Parcel || option.code == this.consumTypes.Works || option.code == this.consumTypes.Machinery) {
        this.currentConsumOption = option;

        if (this.currentConsumOption.code == this.consumTypes.Works && this.applyPreselectedWorksDataIfAvailable()) {
          return;
        }

        if (this.currentConsumOption.code == this.consumTypes.Parcel) {
          this.selectedParcelSourceOption = null;
          this.setParcelViewMode(this.parcelInitialView);
        }
        this.currentStep = this.currentStep + 1;
        this.setTitle();
      } else {
        this.$refs.toastMessage.showInfo(this.$t("common.feature_in_development"));
      }
    },
    applyPreselectedWorksDataIfAvailable() {
      if (this.preselectedWorksApplied) {
        return false;
      }

      const data = this.preselectedWorksData;
      if (!data || !Array.isArray(data.parcels) || data.parcels.length === 0) {
        return false;
      }

      const machineMap = {};
      const addMachine = (machineEntry) => {
        if (!machineEntry) {
          return;
        }

        const machinePayload =
          machineEntry?.machine && typeof machineEntry.machine === "object" ? machineEntry.machine : machineEntry;
        const machineUuid = machinePayload?.uuid || machineEntry?.work_machine_uuid || machineEntry?.machine_uuid || null;
        const registrationNumber = machinePayload?.registration_number || machineEntry?.registration_number || "";
        const machineName = registrationNumber || machinePayload?.name || machineEntry?.machine_name || "";

        if (!machineName && !machineUuid) {
          return;
        }

        const key = machineUuid || machineName;
        if (!machineMap[key]) {
          machineMap[key] = machineUuid
            ? {
                uuid: machineUuid,
                name: machineName,
                registration_number: registrationNumber,
              }
            : {
                name: machineName,
                registration_number: registrationNumber,
              };
        }
      };

      if (Array.isArray(data.machines)) {
        data.machines.forEach((machine) => addMachine(machine));
      }

      if (Array.isArray(data.work_machines)) {
        data.work_machines.forEach((machine) => addMachine(machine));
      }

      data.parcels.forEach((parcel) => {
        addMachine(parcel?.machine);

        if (Array.isArray(parcel?.work_machines)) {
          parcel.work_machines.forEach((machine) => addMachine(machine));
        }

        if (parcel?.machine_name || parcel?.machine_registration_number || parcel?.machine_uuid) {
          addMachine({
            uuid: parcel.machine_uuid,
            name: parcel.machine_name,
            registration_number: parcel.machine_registration_number,
          });
        }
      });

      this.selectedWorksData = {
        works: Array.isArray(data.works) ? data.works.map((item) => ({ ...item })) : [],
        parcels: data.parcels.map((item) => ({
          ...item,
          spc_items: Array.isArray(item.spc_items) ? [...item.spc_items] : [],
          spc_items_info: Array.isArray(item.spc_items_info) ? item.spc_items_info.map((spc) => ({ ...spc })) : [],
        })),
        machines: Object.values(machineMap),
      };

      this.preselectedWorksApplied = true;
      this.currentStep = 2;
      this.currentItem = this.consumSteps[this.currentStep];
      this.setTitle();
      return true;
    },
    applyPreselectedMachineIfAvailable() {
      if (this.preselectedMachineApplied) {
        return false;
      }

      const machine = this.preselectedMachineForConsum;
      if (!machine || !machine.uuid) {
        return false;
      }

      this.machineConsumData.machines = [
        {
          uuid: machine.uuid,
          name: machine.name || machine.registration_number || "",
        },
      ];

      this.preselectedMachineApplied = true;
      this.currentStep = 2;
      this.currentItem = this.consumSteps[this.currentStep];
      this.setTitle();
      this.consumePendingPreselectedProducts();
      return true;
    },
    selectParcelSelectionOption(option) {
      if (!option || !option.code) {
        return;
      }
      this.selectedParcelSourceOption = option.code;
      this.setParcelViewMode(option.code);
    },
    removeSelectedParcel(layer) {
      const index = this.selectedLayers.findIndex((l) => l.uuid === layer.uuid);
      if (index > -1) {
        this.selectedLayers.splice(index, 1);
      }
      this.setTitle();
    },
    addSelectedParcel(layer) {
      layer.surface = Number.parseFloat(layer.surface);
      if (!this.selectedLayers.some((l) => l.uuid === layer.uuid)) {
        this.selectedLayers.push({ ...layer });
      }
      this.setTitle();
    },
    toggleLayerFromList(layer) {
      if (!layer || !layer.uuid) {
        return;
      }
      if (this.selectedLayers.some((l) => l.uuid === layer.uuid)) {
        this.removeSelectedParcel(layer);
      } else {
        this.addSelectedParcel(layer);
      }
    },
    resetSelectedParcels() {
      if (this.selectedLayers.length === 0) {
        return;
      }
      this.selectedLayers = [];
      this.setTitle();
    },
    setParcelViewMode(mode) {
      if (mode === "list") {
        const mapSeasonUuid = this.$refs.googlemap?.filterData?.season_uuid;
        if (mapSeasonUuid) {
          this.season_uuid_local = mapSeasonUuid;
        }
      }
      if (!this.enableParcelMapListToggle) {
        this.parcelViewMode = "map";
        return;
      }
      this.parcelViewMode = mode === "list" ? "list" : "map";
    },
    viewSelectedParcelsOnMap() {
      if (this.currentConsumOption.code == this.consumTypes.Works) {
        if (this.selectedWorksData.parcels.length) this.workParcelMapVisible = true;
        return;
      }
      this.parcelSubPhase = "parcel";
      this.setParcelViewMode("map");
      this.currentStep = this.currentStep - 1;
      this.setTitle();
    },
    onSeasonChange(seasonUuid) {
      const nextSeasonUuid = seasonUuid || this.currentSeason?.uuid || "";
      this.season_uuid_local = nextSeasonUuid;
    },
    showMapFilter() {},
    showToastMessage(type, message) {
      this.$refs.toastMessage.showToastMessage(type, message);
    },
    continueFromMap() {
      // check if all selected layers are from the same legal entity, and set the legal entity filter for products(filterData)
      if (this.allow_stock_movement_only_in_legal_entity && this.selectedLayers.length > 0) {
        const departmentLegalEntityUuid = this.selectedLayers[0].department_legal_entity_uuid;
        const allSameLegalEntity = this.selectedLayers.every((layer) => layer.department_legal_entity_uuid === departmentLegalEntityUuid);

        if (!allSameLegalEntity) {
          this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_multiple_legal_entities_selected_parcels"));
          return;
        }

        this.$set(this.filterData, "department_legal_entity_uuid", departmentLegalEntityUuid);
      }

      const department_legal_entity_uuid = this.filterData?.department_legal_entity_uuid ?? null;
      // check if all selected products are from the same legal entity as the selected layers
      if (this.allow_stock_movement_only_in_legal_entity && department_legal_entity_uuid && this.consumData.products.length > 0) {
        const before_count = this.consumData.products.length;
        this.consumData.products = this.consumData.products.filter(
          (product) => product.warehouse_department_legal_entity_uuid === department_legal_entity_uuid,
        );
        const after_count = this.consumData.products.length;

        if (before_count != after_count) {
          this.$refs.toastMessage.showInfo(this.$t("stock_mobile.form.products_removed_from_consumption", { count: before_count - after_count }));
        }
      }

      // preselected products are provided when starting quick consum from stock.
      if (this.pendingPreselectProducts == null) {
        this.advanceFromParcelSelection();
      } else {
        // if selecteed layer legal entity is different from the legal entity of the preselected reception products
        if (
          this.allow_stock_movement_only_in_legal_entity &&
          department_legal_entity_uuid != null &&
          this.preselectProducts.warehouse_department_legal_entity_uuid != department_legal_entity_uuid
        ) {
          this.$refs.toastMessage.showError(
            this.$t("stock_mobile.form.error_reception_warehouse_legal_entity_mismatch"),
          );
          this.preselectProducts = null;
          this.advanceFromParcelSelection();
        } else if (this.preselectProducts.products && this.preselectProducts.products.length > 0) {
          // add receptioned products to consumData products
          this.preselectProducts.products.forEach((product) => {
            if (!this.consumData.products.some((p) => p.uuid === product.uuid)) {
              this.consumData.products.push({
                uuid: product.uuid,
                name: product.name,
                quantity: product.quantity || 0,
                product_type: product.product_type,
                product_type_uuid: product.product_type.uuid,
                warehouse_uuid: this.preselectProducts.warehouse.uuid,
                warehouse_name:
                  product.stock_list.find((stock) => stock.warehouse_uuid === this.preselectProducts.warehouse.uuid)?.warehouse_name ||
                  this.preselectProducts.warehouse.name,
                warehouse_quantity:
                  product.stock_list.find((stock) => stock.warehouse_uuid === this.preselectProducts.warehouse.uuid)?.quantity || 0,
                warehouse_department_legal_entity_uuid: this.preselectProducts.warehouse_department_legal_entity_uuid,
                measure_unit: product.measure_unit,
                measure_unit_id: product.measure_unit.id,
                stock_list: product.stock_list,
                lot_management: product.lot_management ?? false,
                lot_items: product.lot_items ?? [],
              });
            }
          });
          this.preselectProducts = null;
          this.consumePendingPreselectedProducts(department_legal_entity_uuid);
          this.advanceFromParcelSelection();
        }
      }
      this.setTitle();
    },
    advanceFromParcelSelection() {
      if (this.is_work_generator_enabled) {
        this.parcelSubPhase = "machines";
      }
      this.currentStep = this.currentStep + 1;
    },
    async continueFromWorks() {
      // Disable the button while waiting for getSelectedItems
      this.continueButtonPressed = true;
      const itemData = await this.$refs.workListSelector.getSelectedItems();
      this.continueButtonPressed = false;
      if (!itemData || !itemData.parcels || itemData.parcels.length === 0) {
        this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_at_least_one_parcel_required"));
        return;
      }

      const parcels = itemData.parcels;
      const works = itemData.works;
      // machine_name
      // Get unique machine names from parcels
      const machines = [...new Set(parcels.map((p) => p.machine_name).filter(Boolean))].map((name) => ({ name }));

      // check if all selected layers are from the same legal entity, and set the legal entity filter for products(filterData)
      if (this.allow_stock_movement_only_in_legal_entity && parcels.length > 0) {
        const departmentLegalEntityUuid = parcels[0].department_legal_entity_uuid;
        const allSameLegalEntity = parcels.every((parcel) => parcel.department_legal_entity_uuid === departmentLegalEntityUuid);

        if (!allSameLegalEntity) {
          this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_multiple_legal_entities_selected_parcels"));
          return;
        }

        this.$set(this.filterData, "department_legal_entity_uuid", departmentLegalEntityUuid);
      }

      if ((parcels && parcels.length > 0) || (works && works.length > 0)) {
        this.currentStep = this.currentStep + 1;

        this.setTitle();
        this.selectedWorksData.works = works;
        this.selectedWorksData.parcels = parcels;
        this.selectedWorksData.machines = machines;
        this.consumePendingPreselectedProducts(this.filterData?.department_legal_entity_uuid ?? null);
      }
    },
    continueFromMachineSelection() {
      const selected = this.$refs.machineSelector?.getSelectedMachines() || [];
      if (!selected.length) {
        this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_select_machinery_for_consumption"));
        return;
      }

      this.machineConsumData.machines = selected.map((m) => ({ uuid: m.uuid, name: m.name || m.registration_number || "" }));
      this.currentStep = this.currentStep + 1;
      this.setTitle();
      this.consumePendingPreselectedProducts();
    },
    applyParcelChanges() {
      this.currentStep = this.currentStep - 1;
      this.setTitle();
    },
    machinesClickParcel() {
      this.parcelSubPhase = "machines";
      this.currentStep = this.currentStep - 1;
      this.setTitle();
    },
    continueFromMachineSelectionParcel() {
      const selected = this.$refs.parcelMachineSelector?.getSelectedMachines() || [];
      if (!selected.length) {
        this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_select_tractor_for_consumption"));
        return;
      }

      this.consumData.work_machines = selected.map((m) => ({
        uuid: m.uuid,
        name: m.name || m.registration_number || "",
        autopropulsat: m.autopropulsat,
        equipment: m.equipment,
        is_dataller: m.is_dataller,
      }));
      this.currentStep = this.currentStep + 1;
      this.parcelSubPhase = "parcel";
      this.setTitle();
    },
    setCurrentSeason(seasons) {
      if (seasons.length === 0) return;

      this.currentSeason = seasons[0];
      seasons.forEach((obj) => {
        if (new Date(obj.created_at) > new Date(this.currentSeason.created_at)) {
          this.$set(this, "currentSeason", obj);
        }
      });
      this.season_uuid_local = this.currentSeason.uuid;
    },
    searchByText(searchText) {
      this.$set(this.filterData, "name", searchText);
    },
    parcelsClick(edit_surface = false) {
      if (this.currentConsumOption.code == this.consumTypes.Parcel) {
        this.parcelSubPhase = "parcel";
      }
      this.currentStep = edit_surface ? this.currentStep + 1 : this.currentStep - 1;
      this.setTitle();
    },
    machinesClick() {
      this.currentStep = this.currentStep - 1;
      this.setTitle();
    },
    productSelected(stock_data, warehouse) {
      this.currentStep = this.currentStep + 1;
      this.setTitle();

      this.consumData.products.push({
        uuid: stock_data.uuid,
        name: stock_data.name,
        quantity: 0,
        lot_management: stock_data.lot_management ?? false,
        lot_items: Array.isArray(stock_data.lot_items) ? stock_data.lot_items : [],
        product_type: stock_data.product_type,
        product_type_uuid: stock_data.product_type.uuid,
        warehouse_uuid: warehouse.warehouse_uuid,
        warehouse_name: warehouse.warehouse_name,
        warehouse_quantity: warehouse.quantity,
        measure_unit: stock_data.measure_unit,
        measure_unit_id: stock_data.measure_unit.id,
        stock_list: stock_data.stock_list,
      });

      setTimeout(() => {
        this.showProductSelector();
      }, 100);
    },
    workSelected(selectedWork) {
      if (selectedWork && selectedWork.length > 0 && selectedWork[0]) {
        this.consumData.work.uuid = selectedWork[0].uuid;
        this.consumData.work.name = selectedWork[0].name;
      }
    },
    async saveConsum(saveAndNew) {
      const lotSumInvalid = this.consumData.products.some((product) => {
        if (!product?.lot_management) {
          return false;
        }
        const items = Array.isArray(product.lot_items) ? product.lot_items : [];
        const sum = items.reduce((acc, item) => acc + (parseFloat(item.quantity) || 0), 0);
        const qty = parseFloat(product.quantity) || 0;
        return Math.abs(sum - qty) > 0.0001 || qty <= 0 || items.some((item) => (parseFloat(item.quantity) || 0) <= 0) || sum <= 0;
      });

      this.saveButtonPressed = true;
      if (this.currentConsumOption.code == this.consumTypes.Machinery) {
        return this.saveMachineConsum(saveAndNew, lotSumInvalid);
      }

      this.$v.consumData.$touch();
      if (!this.$v.consumData.$invalid && !lotSumInvalid) {
        let consumDataForSave = {
          products: this.consumData.products,
          parcels: [],
          consum_date: this.consumData.consum_date,
          work_machines: this.consumData.work_machines,
          work_uuid: this.consumData.work.uuid,
          notes: this.consumData.notes,
        };

        if (this.currentConsumOption.code == this.consumTypes.Works) {
          // munkálatra vonatkozó parcellák
          this.selectedWorksData.parcels.forEach((p) => {
            if (p.uuid && p.uuid.length > 0) {
              // season on parcel has culture spc_items
              let spc_uuids = [];
              if (p.spc_items && p.spc_items.length > 0) {
                p.spc_items.forEach((spc) => {
                  if (spc_uuids.includes(spc) == false) {
                    spc_uuids.push(spc);
                  }
                });
              }

              if (!spc_uuids.length) {
                this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_exactly_one_spc_per_parcel"));
                return;
              }

              if (spc_uuids.length > 1) {
                // egy munkálat parcella elem állhat több spc ből ha egy napra több részben viszik fel a munkálatot
                spc_uuids.forEach((spc_uuid) => {
                  const surface_worked_item = p.spc_items_info.filter((spc_item) => spc_item.uuid === spc_uuid);
                  const net_surface_worked = surface_worked_item.length > 0 ? surface_worked_item[0].net_surface_worked : 0;

                  if (!net_surface_worked || net_surface_worked <= 0) {
                    this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_worked_surface_gt_zero_per_spc"));
                    return;
                  }

                  consumDataForSave.parcels.push({
                    uuid: p.uuid,
                    surface: net_surface_worked,
                    season_uuid: p.season_uuid,
                    spc_uuid: spc_uuid,
                  });
                });
              } else {
                consumDataForSave.parcels.push({
                  uuid: p.uuid,
                  surface: p.surface_worked,
                  season_uuid: p.season_uuid,
                  spc_uuid: spc_uuids[0],
                });
              }
            }
          });
        } else {
          this.selectedLayers.forEach((l) => {
            if (l.parcel_uuid && l.parcel_uuid.length > 0) {
              consumDataForSave.parcels.push({
                uuid: l.parcel_uuid,
                surface: l.surface,
                season_uuid: l.season_uuid,
              });
            }
          });
        }

        if (consumDataForSave.parcels.length <= 0) {
          this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_at_least_one_parcel_required"));
          this.saveButtonPressed = false;
          return;
        }

        if (
          this.currentConsumOption.code == this.consumTypes.Parcel &&
          this.is_work_generator_enabled &&
          this.consumData.work_machines.length > 1
        ) {
          const splitResult = await this.$refs.machineParcelSplitPopup.open(
            this.consumData.products,
            this.consumData.work_machines,
            this.selectedLayers,
          );
          if (!splitResult) {
            this.saveButtonPressed = false;
            return;
          }

          const machineSplitsByProduct = new Map(splitResult.map((row) => [row.product_uuid, row.machine_splits]));
          consumDataForSave.products = this.consumData.products.map((product) => ({
            ...product,
            machine_splits: machineSplitsByProduct.get(product.uuid) || [],
          }));
        }

        this.createConsum(consumDataForSave)
          .then((response) => {
            this.$refs.toastMessage.showSuccess(this.$t("stock_mobile.form.consumption_saved"));
            if (saveAndNew) {
              this.saveButtonPressed = false;
              this.resetForm();
            } else {
              this.closeTransactions(this.$t("stock_mobile.form.consumption_saved"));
            }
          })
          .catch((e) => {
            this.saveButtonPressed = false;
            this.$refs.toastMessage.showError(extractErrorMessage(this, e));
          });
      } else {
        this.saveButtonPressed = false;

        if (lotSumInvalid) {
          this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_lot_sum_must_match"));
          return;
        }

        if (this.consumData.products.length <= 0) {
          this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_at_least_one_product_required"));
          return;
        }

        if (this.consumData.products.some((product) => !product.uuid || !product.warehouse_uuid || product.quantity <= 0)) {
          this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_products_require_warehouse_and_qty"));
          return;
        }

        if (this.is_work_generator_enabled && (this.$v.consumData.work_machines.$invalid || this.$v.consumData.work.uuid.$invalid)) {
          this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_select_tractor_and_work"));
        }
      }
    },
    async saveMachineConsum(saveAndNew, lotSumInvalid) {
      if (lotSumInvalid) {
        this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_lot_sum_must_match"));
        this.saveButtonPressed = false;
        return;
      }

      if (this.machineConsumData.machines.length === 0) {
        this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_select_machinery_for_consumption"));
        this.saveButtonPressed = false;
        return;
      }

      if (this.consumData.consum_date === "" || this.consumData.consum_date === null) {
        this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_consumption_date_required"));
        this.saveButtonPressed = false;
        return;
      }

      if (this.consumData.products.length <= 0) {
        this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_at_least_one_product_required"));
        this.saveButtonPressed = false;
        return;
      }

      if (this.consumData.products.some((product) => !product.uuid || !product.warehouse_uuid || product.quantity <= 0)) {
        this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_products_require_warehouse_and_qty"));
        this.saveButtonPressed = false;
        return;
      }

      let machineSplitsByProduct;
      if (this.machineConsumData.machines.length === 1) {
        const machine = this.machineConsumData.machines[0];
        machineSplitsByProduct = new Map(
          this.consumData.products.map((product) => [
            product.uuid,
            [{ work_machine_uuid: machine.uuid, quantity: parseFloat(product.quantity) || 0 }],
          ]),
        );
      } else {
        const splitResult = await this.$refs.machineSplitPopup.open(this.consumData.products, this.machineConsumData.machines);
        if (!splitResult) {
          this.saveButtonPressed = false;
          return;
        }
        machineSplitsByProduct = new Map(splitResult.map((row) => [row.product_uuid, row.machine_splits]));
      }

      const consumDataForSave = {
        products: this.consumData.products.map((product) => ({
          ...product,
          machine_splits: machineSplitsByProduct.get(product.uuid) || [],
        })),
        consum_date: this.consumData.consum_date,
        notes: this.consumData.notes,
      };

      this.createMachineConsum(consumDataForSave)
        .then((response) => {
          this.$refs.toastMessage.showSuccess(this.$t("stock_mobile.form.consumption_saved"));
          if (saveAndNew) {
            this.saveButtonPressed = false;
            this.resetMachineForm();
          } else {
            this.closeTransactions(this.$t("stock_mobile.form.consumption_saved"));
          }
        })
        .catch((e) => {
          this.saveButtonPressed = false;
          this.$refs.toastMessage.showError(extractErrorMessage(this, e));
        });
    },
    resetForm() {
      this.$v.$reset();
      this.selectedLayers = [];
      this.consumData.products = [];
      this.consumData.parcels = [];
      this.consumData.work_machines = [];
      this.consumData.work = {
        uuid: null,
        name: "",
      };
      this.consumData.notes = "";
      this.selectedWorksData.works = [];
      this.selectedWorksData.parcels = [];
      this.selectedWorksData.machines = [];
      this.preselectedWorksApplied = false;
      this.selectedParcelSourceOption = null;
      this.parcelSubPhase = "parcel";
      this.pendingPreselectProducts = this.clonePreselectedProducts(this.preselectProducts);
      this.setParcelViewMode(this.parcelInitialView);

      if (this.$refs.comboWorkTypes) {
        this.$refs.comboWorkTypes.resetControl();
      }
      if (this.$refs.googlemap) {
        this.$refs.googlemap.resetSelection();
        this.$refs.googlemap.refreshLayers();
      }
    },
    resetMachineForm() {
      this.$v.$reset();
      this.selectedLayers = [];
      this.consumData.products = [];
      this.consumData.notes = "";
      this.machineConsumData.machines = [];
    },
    closeTransactions(message) {
      this.$emit("closeTransactions", message);
    },
    showCalendarSelector() {
      this.is_date_selector_visible = !this.is_date_selector_visible;
    },
    calendarDayChosen(data) {
      this.is_date_selector_visible = false;
    },
    onDateSelected(date) {
      this.consumData.consum_date = date.selectedDate;
    },
    showProductSelector() {
      if (!this.consumData.consum_date) {
        this.$refs.toastMessage.showError(this.$t("stock_mobile.form.error_consumption_date_required"));
        return;
      }
      this.productSelectorVisibility = true;
    },
    hideProductSelector() {
      this.productSelectorVisibility = false;
    },
    applyProductsSelection(products) {
      this.consumData.products = Array.isArray(products) ? products : [];
    },
  },
  mounted() {
    this.getGroupByCode({
      code: "STOCK_MANAGEMENT",
    }).then((response) => {
      let _setting = response.items.find((obj) => obj.code == "USE_CURRENT_DATE_ON_CREATION");
      this.preselectDate = _setting?.value == "1";
      if (this.preselectDate) {
        this.consumData.consum_date = moment().format(this.getDefaultDateFormat);
      }

      _setting = response.items.find((obj) => obj.code == "ALLOW_STOCK_MOVEMENT_ONLY_IN_LEGAL_ENTITY");
      this.allow_stock_movement_only_in_legal_entity = false;
      if (_setting !== undefined) {
        this.allow_stock_movement_only_in_legal_entity = _setting?.value == "1";
      }

      _setting = response.items.find((obj) => obj.code == "PARCEL_CONSUM_WORK_GENERATOR_ENABLED");
      this.is_work_generator_enabled = false;
      if (_setting !== undefined) {
        this.is_work_generator_enabled = _setting?.value == "1";
      }

      if (this.is_work_generator_enabled) {
        this.getWorkMachines({
          enablePagination: 0,
          limit: 9999,
          autopropulsat: 1,
        }).then((response) => {
          this.workMachines = response.data;
        });

        this.getWorks({
          enablePagination: 0,
          limit: 9999,
        }).then((response) => {
          this.workTypes = response.data;
        });
      }
    });

    this.getSeasons();
    this.setParcelViewMode(this.parcelInitialView);
    this.setTitle();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/stockMobile/consum.scss";
@import "@fortawesome/fontawesome-free/css/all.css";
</style>
